import api from "../axiosIntercepture";
import { getApiErrorMessage } from "../../utils/apiErrorMessage";

export async function storerRequest(method, url, body, fallback) {
  try {
    const response = method === "delete" ? await api.delete(url) : await api[method](url, body);
    const data = response?.data;
    if (data && data.success === false) {
      throw new Error(getApiErrorMessage(data, fallback));
    }
    return data?.data ?? data;
  } catch (err) {
    if (err?.isAxiosError || err?.response) {
      throw new Error(getApiErrorMessage(err, fallback));
    }
    throw err instanceof Error ? err : new Error(fallback);
  }
}

/** Body for `fetch-multi-dynamic`. `page` is the table's 0-based index. */
export function storerListBody(page = 0, pageSize = 10, filters = {}) {
  return {
    page: (Number(page) || 0) + 1,
    limit: Number(pageSize) || 10,
    filters: filters && typeof filters === "object" ? filters : {},
  };
}

/**
 * POST `.../fetch-multi-dynamic`.
 * Accepts `{ success, data: { data, totalCount, page, limit, totalPages } }`
 * and a bare `{ data, totalCount, ... }` body.
 */
export async function storerFetchList(url, page = 0, pageSize = 10, filters = {}) {
  const fallback = "Failed to load records";
  try {
    const response = await api.post(url, storerListBody(page, pageSize, filters));
    const body = response?.data;
    if (body && body.success === false) {
      throw new Error(getApiErrorMessage(body, fallback));
    }

    const layer = body?.data ?? body;
    const payload =
      layer && !Array.isArray(layer) && Array.isArray(layer.data) ? layer : body;
    const rows = Array.isArray(payload?.data)
      ? payload.data
      : Array.isArray(layer)
        ? layer
        : [];

    return {
      data: rows,
      total: Number(payload?.totalCount ?? payload?.total ?? rows.length) || 0,
      page: payload?.page,
      limit: payload?.limit,
      totalPages: payload?.totalPages,
    };
  } catch (err) {
    if (err?.isAxiosError || err?.response) {
      throw new Error(getApiErrorMessage(err, fallback));
    }
    throw err instanceof Error ? err : new Error(fallback);
  }
}

export function requireId(id, fallback) {
  if (!id) throw new Error(fallback || "Missing record id");
  return encodeURIComponent(id);
}
